import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiNieuwegeinSchipholPage() {
  return (
    <CityAirportTemplate
      city="Nieuwegein"
      airport="schiphol"
      airportName="Schiphol Airport"
      price={57.50}
      distance="45 km"
      duration="35-40 minuten"
    />
  );
}
